import { InviteCreateDtoRoleEnum, InviteSelectDtoRoleEnum } from '@@types/api.types';
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@components/ui/select';
import { FunctionComponent } from 'react';

export const removeRole = 'REMOVE';

interface RoleSelectDropdownProps {
  currentRole?: InviteSelectDtoRoleEnum | InviteCreateDtoRoleEnum;
  disabled?: boolean;
  isAdmin?: boolean;
  onChange?: (currentValue: any) => void;
  showRemove?: boolean;
}

export const RoleSelectDropdown: FunctionComponent<RoleSelectDropdownProps> = ({
  currentRole,
  disabled,
  isAdmin,
  onChange,
  showRemove,
}) => (
  <Select
    value={currentRole || InviteSelectDtoRoleEnum.Collaborator}
    onValueChange={onChange}
    disabled={!isAdmin || disabled}
  >
    <SelectTrigger className="h-10 after:rounded-lg bg-gray-100 p-3 border-gray-200 border-solid border">
      <SelectValue placeholder="Select role" />
    </SelectTrigger>
    <SelectContent>
      <SelectGroup>
        {isAdmin && showRemove && (
          <SelectItem
            className="text-red-500"
            value={removeRole}
          >
            Remove
          </SelectItem>
        )}
        {Object.values(InviteSelectDtoRoleEnum).map((role) => (
          <SelectItem
            key={role}
            value={role}
          >
            {role}
          </SelectItem>
        ))}
      </SelectGroup>
    </SelectContent>
  </Select>
);
